import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";

const items = [
  { tsCont: "The labels for my kids’ school supplies last all year, even after multiple washes. Highly recommend!", user: "Mrs. Agatha K. - Kirinyaga" },
  { tsCont: "We use the labels for uniforms, Water Bottles, and stationery. They stick well and survive the school year — so glad we found this service!", user: "Mr. Joseph N. – Ongata Rongai" },
  { tsCont: "The iron-on and stick-on labels for our uniforms were perfect — durable, neat, and easy to apply. Parents have been asking where we got them from!", user: "Teacher. Faith Chebet - Thika" },
  { tsCont: "We ordered custom labels and stationery for our sports tournament. Everything arrived on time and looked fantastic — professional and durable.", user: "Mr. Mohammed K – Eldoret" },
  { tsCont: "The quality of the iron-on labels exceeded our expectations. They’ve held up through heavy-duty work uniforms.", user: "Mrs. Sophia K. Cherono - Kericho" },
];

export default function AutoCarousel() {

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % items.length);
    }, 3000); // change slide every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel">
      <div className="squareCard">
        <p>{items[index].tsCont}</p>
        
        <span>- {items[index].user}</span>
      </div>
    </div>
  );
}